module.exports = __webpack_public_path__ + "static/img/logo.7922c42.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.webp
// module id = o7zP
// module chunks = 6